import { render, staticRenderFns } from "./MensajeValidacion.vue?vue&type=template&id=0a375188&scoped=true&"
import script from "./MensajeValidacion.vue?vue&type=script&lang=ts&"
export * from "./MensajeValidacion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a375188",
  null
  
)

export default component.exports